

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs des champs de modifications de l'utilisateur

import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class Validation{


  // obligatoire
  static requiredValidator(controlName: string): ValidatorFn {

    return (name: AbstractControl): ValidationErrors |null=>{

      if(!name.value)
      {
        return {  error: true, message: `${controlName} est obligatoire.` }
      }
      return null;
    };
  }

  static descriptionValidator(controlName: string): ValidatorFn {
    let minlength=10;

    return (name: AbstractControl): ValidationErrors |null=>{

      if(name.value!='' && name.value != null)
      {
        if(name.value.length < minlength){
          return {  error: true, message: `${controlName} doit contenir au moins 10 caractères.` }
        }

      }
      return null;
    };
  }

  // le format de l'email

  static emailFormatValidator(controlName: string):ValidatorFn {

    let format='^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    return (email: AbstractControl): ValidationErrors |null=>{

      if(!email.value)
      {
        return {  error: true, message: `${controlName} est obligatoire.` }
      }

      if(!email.value.match(new RegExp(format)))
    {
      return { error: true, message: `Veuillez saissir une adresse ${controlName} valide, au format yohan@gmail.com.` }
    }
      return null;
    };


  }


  static passwordFormatValidator(controlName: string): ValidatorFn {

    let minlength = 8;
    const isNonWhiteSpace = /^\S*$/;
    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    const isContainsNumber = /^(?=.*[0-9]).*$/;
    const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    return (password: AbstractControl): ValidationErrors | null => {

      if (!password.value) {
        return { error: true, message: `${controlName} est obligatoire.` }
      }

      if (password.value.length < minlength) {
        return { error: true, message: `${controlName} doit contenir au moins ${minlength} caractères.` }
      }
      if ((password.value != null) && (password.value.startsWith(' ') && password.value.endsWith(' '))) {
        return {
          error: true,
          message: `${controlName} Ce champs ne peut pas contenir des espaces.`,
        }
      }

      if (password.value != null && !isNonWhiteSpace.test(password.value) || !isContainsUppercase.test(password.value) ||
    !isContainsLowercase.test(password.value) || !isContainsNumber.test(password.value) ||
    !isContainsSymbol.test(password.value)) {
    return { error: true, message: `${controlName} doit contenir au moins 8 caractères (lettre miniscule et majuscule, des chiffres et des caractères spéciaux).`}
}
    }

  }



  static checkPasswordValidity(control: FormControl): ValidationErrors | null{
    const isNonWhiteSpace = /^\S*$/;
    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    const isContainsNumber = /^(?=.*[0-9]).*$/;
    const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    if (control.value != null && !isNonWhiteSpace.test(control.value) || !isContainsUppercase.test(control.value) ||
        !isContainsLowercase.test(control.value) || !isContainsNumber.test(control.value) ||
        !isContainsSymbol.test(control.value)) {
      return {'checkPasswordValidity': true};
    }
    return null;
    // if (!isValidLength.test(value)) {
    //   return "Password must be 8-16 Characters Long.";
    // }
  }




  // old
  // 👧👧🔥🔥🔥🔥🔥 ---------------------------------------------------------------

  static emailValidator(email: FormControl):ValidationErrors |null {

    let champ="e-mail";
    let format='^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

    if(!email.value)
    {
      return { error: true, message: `L'adresse ${champ} est obligatoire.` }
    }

    if(!email.value.match(new RegExp(format)))
    {
      return { error: true, message: `Veuillez saissir une adresse ${champ} valide.` }
    }

    return null;
  }
  // 👧👧🔥🔥🔥🔥🔥 ---------------------------------------------------------------



  // 👧👧🔥🔥🔥🔥🔥 ---------------------------------------------------------------

    static passWordValidator(controlName: string, minlength: number,
      maxlength: number):ValidatorFn {

      let format='^(?=.*\d)([a-zA-Z\d$@%*+\-_!]{8,15})$';

      return (password: AbstractControl): ValidationErrors |null=>{

        if(!password.value.length)
        {
          return {  error: true, message: `${controlName} est obligatoire.` }
        }
        if(!password.value.match(new RegExp(format)))
      {
        return { error: true,
          message: `${controlName} doit contenir au moins un chiffre pour un mot de passe fort.`, }
      }
      if(password.value.length<minlength){
        return { error: true, message: `${controlName} doit contenir au moins ${minlength} caractères.` }
      }
      if((password.value != null) && (password.value.startsWith(' ') && password.value.endsWith(' ')))
      {
        return { error: true,
          message: `${controlName} Ce champs ne peut pas contenir des espaces.`, }

      }
        return null;
      };
    }

  // 👧👧🔥🔥🔥🔥🔥 nameValidator---------------------------------------------------------------

  static nameValidator_updated(controlName: string, minLength: number, maxLength: number): ValidatorFn {
    let pattern = '^[A-Za-zéàèîôêûïëüö\'0-9 -]+$';

    return (name: AbstractControl): ValidationErrors | null => {
        if (!name.value) {
            return { error: true, message: `${controlName} est obligatoire.` };
        }
        if (!name.value.match(new RegExp(pattern))) {
            return { error: true, message: `${controlName} ne doit contenir que des lettres, des chiffres, des apostrophes et des espaces.` };
        }
        if (name.value.length < minLength) {
            return {
                error: true,
                message: `${controlName} doit contenir au moins ${minLength} caractères.`,
            };
        }
        if (name.value.length > maxLength) {
            return {
                error: true,
                message: `${controlName} doit contenir au plus ${maxLength} caractères.`,
            };
        }
        if (name.value.trim() !== name.value) {
            return { error: true, message: `Les espaces de début ou de fin ne sont pas autorisés.` };
        }
        return null;
    };
}


  static nameValidator(controlName: string, minLength: number, maxLength: number): ValidatorFn {
    let patternalphabets = '^[A-Za-zéàèîôêûïëüö -]+$';

    return (name: AbstractControl): ValidationErrors |null=>{

      if(!name.value) {
        return {  error: true, message: `${controlName} est obligatoire.` }
      }
      if(!name.value.match(new RegExp(patternalphabets))) {
        return { error: true,
          message: `${controlName} ne doit contenir que des lettres.`, }
      }
      if(name.value.length < minLength ) {
        return {
          error: true,
          message: `${controlName} doit contenir au moins  ${minLength} lettres.`,
        }
      }
      if(name.value.length > maxLength ) {
        return {
          error: true,
          message: `${controlName} doit contenir au plus  ${maxLength} lettres.`,
        }
      }
      if((name.value != null) && (name.value.startsWith(' ') && name.value.endsWith(' '))) {
        return { error: true,
          message: `Les espaces de début ou de fin ne sont pas autorisés.`, }
      }
      return null;
    };
  }

  //End of white space

  static nameAlphNumValidator(controlName: string, minLength: number,
    maxLength: number): ValidatorFn {
    let patternalphabets = '^(\s)*[a-zA-Z0-9éàèîôêûïëüö -]+$';


    return (name: AbstractControl): ValidationErrors |null=>{

      if(!name.value)
      {
        return {  error: true, message: `${controlName} est obligatoire.` }
      }
      if(!name.value.match(new RegExp(patternalphabets)))
    {
      return { error: true,
        message: `Le ${controlName} ne doit contenir que des lettres et des chiffres.`, }
    }

      if((name.value != null) && (name.value.startsWith(' ') && name.value.endsWith(' ')))
      {
        return { error: true,
          message: `${controlName} Ce champs ne peut pas contenir des espaces.`, }

      }

    if(name.value.length < minLength )
    {
      return {
        error: true,
        message: `${controlName} doit contenir au moins  ${minLength} caractères.`,
      }

    }
    if(name.value.length > maxLength )
    {
      return {
        error: true,
        message: `${controlName} doit contenir au plus  ${maxLength} caractères.`,
      }
    }

      return null;
    };
  }

  static cityValidator(controlName: string, minLength: number, maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return { error: true, message: `${controlName} est obligatoire.` };
      }

      const pattern = /^[a-zA-Z\s-]*$/; // Permet uniquement des lettres, espaces et le caractère '-'

      if (!pattern.test(value)) {
        return {
          error: true,
          message: `${controlName} ne doit contenir que des lettres et le caractère '-'.`,
        };
      }

      if (value.length < minLength) {
        return {
          error: true,
          message: `${controlName} doit contenir au moins ${minLength} caractères.`,
        };
      }

      if (value.length > maxLength) {
        return {
          error: true,
          message: `${controlName} doit contenir au plus ${maxLength} caractères.`,
        };
      }

      return null;
    };
  }

  static stringValidator(controlName: string, minLength: number, maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return { error: true, message: `${controlName} est obligatoire.` };
      }

      const pattern = /^[a-zA-Z\s]*$/; // Permet uniquement des lettres majuscules, minuscules et des espaces

      if (!pattern.test(value)) {
        return {
          error: true,
          message: `${controlName} ne doit contenir que des lettres.`,
        };
      }

      if (value.length < minLength) {
        return {
          error: true,
          message: `${controlName} doit contenir au moins ${minLength} caractères.`,
        };
      }

      if (value.length > maxLength) {
        return {
          error: true,
          message: `${controlName} doit contenir au plus ${maxLength} caractères.`,
        };
      }

      return null;
    };
  }


  //----------
  static phoneValidator(controlName: string, minLength: number, maxLength: number): ValidatorFn {

    let pattern = '^[0-9+]+(\.?[0-9]+)?$';

    return (phone: AbstractControl): ValidationErrors |null=>{

      if(!phone.value)
      {
        return {  error: true, message: `${controlName} est obligatoire.` }
      }
      if(!phone.value.match(new RegExp(pattern)))
    {
      return { error: true,
        message: `${controlName} ne doit contenir que des chiffres.`, }
    }
    if(phone.value.length < minLength )
    {
      return {
        error: true,
        message: `${controlName} doit contenir au moins  ${minLength} chiffres.`,
      }

    }
    if(phone.value.length > maxLength )
    {
      return {
        error: true,
        message: `${controlName} doit contenir au plus  ${maxLength} chiffres`,
      }
    }
      return null;
    };
  }


  static checkOnlyNumberValidator(control: FormControl): ValidationErrors | null{
    // const isNonWhiteSpace = /^\S*$/;
    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    if (control.value != null && isContainsUppercase.test(control.value) || isContainsLowercase.test(control.value) || isContainsSymbol.test(control.value)) {
      return { error: true,
        message: `Ce champs `,};
    }else{
      return null;
    }
  }



    //Whitespace validation
    static notOnlyWhitespace(control: FormControl): ValidationErrors | null{
      // check if string only contains whitespace
      if((control.value != null) && (control.value.trim().length === 0 || control.value.startsWith(' ') || control.value.endsWith(' '))){
        //invalid, return error object
        return {'notOnlyWhitespace': true};
      }else{
        // valid, return null
        return null;
      }
    }


    static checkValidOnlyLetterOrNumber(control: FormControl): ValidationErrors | null{
      const isNonWhiteSpace = /^\S*$/;
      const isContainsSymbol = /^(?=.*[~`!@#$%^*()+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
      if(control.value != null && isContainsSymbol.test(control.value)){
        return {'checkValidOnlyLetterOrNumber': true};
      }else{
        return null;
      }
    }


    static checkOnlyLetterValidator(control: FormControl): ValidationErrors | null{
      const isContainsNumber = /^(?=.*[0-9]).*$/;
      const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
      if (control.value != null && isContainsNumber.test(control.value) || isContainsSymbol.test(control.value)) {
        return {'checkOnlyLetterValidator': true};
      }else{
        return null;
      }
    }

}


